import { render, staticRenderFns } from "./ForgetPasswordOTP.vue?vue&type=template&id=4166da66&scoped=true"
import script from "./ForgetPasswordOTP.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordOTP.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswordOTP.vue?vue&type=style&index=0&id=4166da66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4166da66",
  null
  
)

export default component.exports